/**
 * Messages module translations - Table section
 */

const table = {
  documentName: "Document Name",
  sku: "SKU",
  dateRequested: "Date Requested",
  dateSubmitted: "Date Submitted",
  status: "Status",
  comment: "Comment",
  approved: "Approved",
  notAccepted: "Not Accepted",
  inReview: "In Review",
  voided: "Voided",
  noRequestsAvailable: "No requests available",
  actions: "Actions",
  requirement: "Requirement",
};

export default table;
